import { fabric } from "fabric";

export class StaticTextObject extends fabric.Textbox {
	static type = "StaticText";
	// @ts-ignore
	public fontURL: string;
	// @ts-ignore
	public textType: string;
	// @ts-ignore
	public colorNumber: number;
	// @ts-ignore
	public fontType: string;
	public shadowColorNumber?: number = undefined;
	public customFontName?: string = undefined;
	public fixedSize: boolean = false;
	public fixedHeightValue: number | undefined;
	public fixedWidthValue: number | undefined;
	public maximumFontSize: number | undefined;
	public brandId?: number;
	initialize(options: StaticTextOptions) {
		const { text, ...textOptions } = options;
		//@ts-ignore
		super.initialize(text, { ...textOptions });

		return this;
	}
	toObject(propertiesToInclude = []) {
		// const originalText = this.getText()
		return fabric.util.object.extend(super.toObject.call(this, propertiesToInclude), {
			fontURL: this.fontURL,
			textType: this.textType,
			customFontName: this.customFontName,
			colorNumber: this.colorNumber,
			shadowColorNumber: this.shadowColorNumber,
			fontType: this.fontType,
			fixedSize: this.fixedSize,
			fixedHeightValue: this.fixedHeightValue,
			fixedWidthValue: this.fixedWidthValue,
			maximumFontSize: this.maximumFontSize,
			brandId: this.brandId,
			// keys: this.keys,
			// originalText: originalText,
			// metadata: this.metadata,
		});
	}
	toJSON(propertiesToInclude = []) {
		// const originalText = this.getText()
		return fabric.util.object.extend(super.toObject.call(this, propertiesToInclude), {
			fontURL: this.fontURL,
			textType: this.textType,
			customFontName: this.customFontName,
			colorNumber: this.colorNumber,
			shadowColorNumber: this.shadowColorNumber,
			fontType: this.fontType,
			fixedSize: this.fixedSize,
			fixedHeightValue: this.fixedHeightValue,
			fixedWidthValue: this.fixedWidthValue,
			maximumFontSize: this.maximumFontSize,
			brandId: this.brandId,
			// keys: this.keys,
			// originalText: originalText,
			// metadata: this.metadata,
		});
	}
	static fromObject(options: StaticTextOptions, callback: Function) {
		return callback && callback(new fabric.StaticText(options));
	}
}

fabric.StaticText = fabric.util.createClass(StaticTextObject, {
	type: StaticTextObject.type,
});
fabric.StaticText.fromObject = StaticTextObject.fromObject;

export type StaticTextOptions = fabric.ITextboxOptions & {
	text: string;
	fontURL: string;
	textType: string;
	customFontName?: string;
	fixedHeightValue: number | undefined;
	fixedWidthValue: number | undefined;
	maximumFontSize: number | undefined;
};

declare module "fabric" {
	namespace fabric {
		class StaticText extends StaticTextObject {
			constructor(options: StaticTextOptions);
		}
	}
}
